import { render, staticRenderFns } from "./LiquorDetail.vue?vue&type=template&id=9602bc40&scoped=true"
import script from "./LiquorDetail.vue?vue&type=script&lang=js"
export * from "./LiquorDetail.vue?vue&type=script&lang=js"
import style0 from "./LiquorDetail.vue?vue&type=style&index=0&id=9602bc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9602bc40",
  null
  
)

export default component.exports